import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import { ITripsModel } from "models/trips";
import ViewIcon from "components/Icons/ViewIcon";
import BanIcon from "components/Icons/BanIcon";
import CheckIcon from "components/Icons/CheckIcon";
import { useTripAlertContext } from "./AlertContext";
import { FaLocationDot } from "react-icons/fa6";

interface IProps {
  trip: ITripsModel;
}

export default function TripAction({ trip }: IProps) {
  const { showCancel, showComplete } = useTripAlertContext();

  const handleCancelClick = () => showCancel(trip);
  const handleCompleteClick = () => showComplete(trip);

  return (
    <div className="flex items-center gap-x-3">
      <Link
        to={RouteName.TRIP_DETAIL.replace(":id", trip.id)}
        className="rounded-full hover:text-black"
        title="View Details"
      >
        <ViewIcon />
      </Link>
      <Link
        to={RouteName.TRIP_ROUTE.replace(":id", trip.id)}
        className="rounded-full hover:text-blue-600 transition-colors"
        title="View on Map"
      >
        <FaLocationDot className="text-lg" />
      </Link>
      {!["completed", "cancelled"].includes(trip.status) && (
        <>
          {trip.status === "ongoing" && (
            <button onClick={handleCompleteClick} className="rounded-ful" title="Complete Trip">
              <CheckIcon />
            </button>
          )}
          {trip.type === "carpooling" && trip.status === "available" && (
            <button onClick={handleCancelClick} className="rounded-ful text-red-600" title="Cancel Trip">
              <BanIcon />
            </button>
          )}
        </>
      )}
    </div>
  );
}
